import { render, staticRenderFns } from "./ElixioPayPage.vue?vue&type=template&id=5b5791a4&"
import script from "./ElixioPayPage.vue?vue&type=script&lang=js&"
export * from "./ElixioPayPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports